import React, { useState, Suspense, useEffect } from "react";
import PropTypes from "prop-types";

//hooks & helpers
import useAxios from "../../hooks/useAxios";
import { updateUrlParams, parseUrlParams } from "../Filters/FilteringHelpers";

// components
const Filters = React.lazy(() => import("./Filters"));
const RiverCard = React.lazy(() => import("./RiverCard"));
const ContentGrid = React.lazy(() => import("../ContentGrid"));
const NoResults = React.lazy(() => import("../NoResults"));
import Loading from "../Loading";

const App = ({ filtersJson }) => {
	// filters, slicing to remove the "all" filter
	const [filters] = useState(
		filtersJson ? JSON.parse(filtersJson).slice(1) : []
	);
	// selected filters
	const [selectedFilters, setSelectedFilters] = useState(
		location.search ? parseUrlParams(location.search) : []
	);
	const [endPoint] = useState("rivers");
	const { response: rivers, isLoading } = useAxios(endPoint);

	useEffect(() => {
		const isPreview = location.search.includes("page_id");
		
		// don't execute when page is in preview mode
		if (isPreview) return;

		updateUrlParams(selectedFilters);
	}, [selectedFilters]);

	const handleSelectedFilter = (filter, event) => {
		// deselecting filter
		if (!event.target.checked) {
			return setSelectedFilters((selectFilter) =>
				selectFilter.filter((f) => f.slug !== filter.slug)
			);
		}
		return setSelectedFilters([...selectedFilters, filter]);
	};

	const filterRiver = () => {
		return rivers.filter((river) => {
			if (river.regions.length > 0) {
				return selectedFilters.some((sf) => {
					return river.regions.some((region) => sf.slug === region.slug);
				});
			}
		});
	};

	const renderCorrectCards = () => {
		//if not filters selected
		if (rivers.length !== 0 && selectedFilters.length === 0) {
			return renderRiverCards(rivers);
		}

		// if no river data
		if (rivers.length === 0) {
			return <NoResults text={"No rivers available"} />;
		}
		// if filters selected
		const filteredRivers = filterRiver();

		// if no results available
		if (filteredRivers.length === 0) {
			return <NoResults text={"No rivers found matching your selection"} />;
		}

		return renderRiverCards(filteredRivers);
	};

	const renderRiverCards = (riversArray) => {
		return riversArray.map((river) => {
			return <RiverCard isSmall={false} riverItem={river} key={river.id} />;
		});
	};

	return (
		<section aria-label="Rivers Index">
			<Suspense fallback={<Loading color={"white"} />}>
				{filters && (
					<Filters
						filters={filters}
						handleSelectedFilter={handleSelectedFilter}
						selectedFilters={selectedFilters}
						setSelectedFilters={setSelectedFilters}
					/>
				)}
				{isLoading ? (
					<Loading color={"white"} />
				) : (
					<ContentGrid row={4.6}>{renderCorrectCards()}</ContentGrid>
				)}
			</Suspense>
		</section>
	);
};

export default App;

App.propTypes = {
	filtersJson: PropTypes.any,
	filtersTaxonomy: PropTypes.string,
};
